/**DATA IMPORT */
import { featuredEvent } from "./events";

export const BOOK_TABLE_PATH = "/book?type=table";

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Menu", path: "/menu" },
  ...(featuredEvent
    ? [{ label: "Republic Day", path: `/events/${featuredEvent.slug}` }]
    : []),
  { label: "Private Events", path: "/#private-events" },
  { label: "Contact", path: "/#contact" },
];
